import React from 'react';

const About = () => {
  return (
    <section className="about animate-on-scroll" id="about">
      <div className="about-img"></div>
      <div className="about-content">
        <h2>About The Clean Knight Co.</h2>
        <p>Founded in 2025, The Clean Knight Co. has been providing top-notch exterior cleaning services to homeowners who take pride in their properties. We combine the latest cleaning technology with eco-friendly solutions to deliver exceptional results.</p>
        <p>Our team of experienced professionals is dedicated to customer satisfaction and paying attention to every detail. We're fully insured and committed to safety in all our operations.</p>
        <a href="#contact" className="about-btn">Learn More</a>
      </div>
    </section>
  );
};

export default About;
// /**
//  * About Component
//  * Renders the about section
//  */

// const About = {
//   render: () => {
//     return `
//       <section class="about" id="about">
//         <div class="about-img"></div>
//         <div class="about-content">
//           <h2>About The Clean Knight Co.</h2>
//           <p>Founded in 2025, The Clean Knight Co. has been providing top-notch exterior cleaning services to homeowners who take pride in their properties. We combine the latest cleaning technology with eco-friendly solutions to deliver exceptional results.</p>
//           <p>Our team of experienced professionals is dedicated to customer satisfaction and paying attention to every detail. We're fully insured and committed to safety in all our operations.</p>
//           <a href="#contact" class="about-btn">Learn More</a>
//         </div>
//       </section>
//     `;
//   },

//   setup: () => {
//     // Any specific setup for the About section can be added here
//   }
// };

// export default About;